import { css } from '@emotion/react';
import { motion } from 'motion/react';
import { theme } from '@frontend/theme';
import { HoveredTimeProgressLine } from './progress-lines';
import { getAdjustedOneHourInMinutes, zIndex } from './utils';

interface Props {
  shouldShowHoverIndicator?: boolean;
  hourLabels: Array<{ label: string; isHalfHour: boolean }>;
  pixelsPerMinute: number;
}

export const CalendarEventHourLines = ({ hourLabels, shouldShowHoverIndicator = false, pixelsPerMinute }: Props) => {
  const hasHalfHours = hourLabels.some((item) => item.isHalfHour);
  const numberOfRows = hourLabels.length;
  const rowHeight = getAdjustedOneHourInMinutes(pixelsPerMinute) / (hasHalfHours ? 2 : 1);

  return (
    <div css={styles.container(numberOfRows, rowHeight)}>
      {shouldShowHoverIndicator && (
        <HoveredTimeProgressLine
          numberOfHours={numberOfRows / (hasHalfHours ? 2 : 1)}
          pixelsPerMinute={pixelsPerMinute}
        />
      )}
      {hourLabels.map(({ label, isHalfHour }, idx) => (
        <motion.div layout='position' key={label + idx} css={[styles.hourLine, isHalfHour && styles.halfHourLine]} />
      ))}
    </div>
  );
};

const styles = {
  container: (numberOfRows: number, rowHeight: number) =>
    css({
      display: 'grid',
      gridRow: '1/-1',
      gridColumn: '1/-1',
      position: 'relative',
      backgroundColor: theme.colors.neutral5,
      gridTemplateRows: `repeat(${numberOfRows}, minmax(${rowHeight}px, 1fr))`,
    }),
  hourLine: css({
    background: theme.colors.neutral20,
    height: 1,
    zIndex: zIndex.horizontalHourLines,
  }),
  halfHourLine: css({
    background: theme.colors.neutral10,
    opacity: 0.6,
  }),
};
